<template>
    <client-only>
    <div
        v-if="!loading"
        class="w-100 d-flex m-0 mb-4 details-main-container row"
    >
        <div
            class="col-12 col-lg-6 col-md-6 col-sm-12 px-2 px-lg-5 px-md-5 pb-5"
        >
            <div class="w-100 h-100 d-flex flex-column" style="gap: 1rem">
                <div class="w-100 h-auto d-flex row">
                    <div
                        class="col-1 d-flex flex-column justify-content-start align-items-center"
                    >
                        <div
                            class="d-flex justify-content-center align-items-center m-1"
                            @click.prevent="arActive"
                            style="cursor: pointer; width: 40px; height: 40px"
                            v-if="design3DUrl.length"
                        >
                            <img
                                src="/images/icon/360.svg"
                                class="w-100"
                                alt=""
                                style=""
                            />
                        </div>
                        <div
                            class="d-flex justify-content-center align-items-center m-1"
                            @click.prevent="qrModalVisibility = true"
                            style="cursor: pointer; width: 40px; height: 40px"
                            v-if="design3DUrl.length"
                        >
                            <img
                                src="/images/icon/ar.svg"
                                class="w-100"
                                alt=""
                                style=""
                            />
                        </div>
                        <div
                            class="d-flex justify-content-center align-items-center m-1"
                            @click.prevent="imageFullScreen"
                            style="cursor: pointer; width: 40px; height: 40px"
                        >
                            <img
                                src="/images/icon/fullscreen.svg"
                                class="w-100"
                                alt=""
                                style=""
                            />
                        </div>
                        <div
                            v-if="authStore.isAuthenticated"
                            class="d-flex justify-content-center align-items-center m-1"
                            style="cursor: pointer; width: 40px; height: 40px"
                            @click.prevent="addToWishList"
                        >

                            <svg
                                id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 54.98 54.98"
                                class="wishlist"
                                :class="{'active-wishlist': isActive}"
                            >
                                <path
                                    class="cls-1"
                                    style="stroke-width: 0px;"
                                    d="m44.51,22.98c-.1.57-.16,1.14-.29,1.7-.42,1.85-1.32,3.46-2.46,4.96-1.59,2.1-3.49,3.89-5.46,5.61-2.67,2.33-5.36,4.64-8.05,6.95-.49.42-.99.46-1.44.07-3.36-2.92-6.73-5.83-10.06-8.79-1.61-1.43-3.05-3.03-4.24-4.84-1.5-2.28-2.28-4.76-1.98-7.51.3-2.75,1.42-5.08,3.61-6.82,1.81-1.43,3.9-2.01,6.19-1.79,2.8.26,4.81,1.79,6.38,4.02.27.38.5.78.77,1.22.1-.17.18-.32.27-.47,1-1.68,2.28-3.08,4.05-3.96,2.14-1.07,4.36-1.15,6.58-.34,3.22,1.17,5.05,3.61,5.83,6.87.13.55.19,1.11.28,1.66v1.46Zm-17.03,17.22c.06-.04.09-.05.11-.07,3-2.61,6.02-5.19,8.99-7.84,1.75-1.57,3.36-3.28,4.57-5.33,1.21-2.05,1.69-4.25,1.15-6.6-.59-2.6-2-4.57-4.59-5.5-1.79-.64-3.57-.54-5.26.4-1.42.79-2.41,2-3.16,3.41-.34.64-.59,1.33-.89,2-.17.39-.48.6-.91.6-.41,0-.72-.19-.89-.57-.07-.14-.12-.29-.17-.43-.6-1.53-1.4-2.93-2.61-4.07-2.88-2.71-7.27-2.09-9.47.7-2.23,2.83-2.43,5.94-.97,9.18.76,1.69,1.94,3.09,3.2,4.42,1.88,1.98,3.96,3.75,6.02,5.52,1.62,1.39,3.24,2.78,4.88,4.19Z"
                                />
                            </svg>
                        </div>
                    </div>
                    <div
                        class="col-11 d-flex justify-content-center align-items-center"
                        style="height: clamp(400px, 60vh, 75vh); overflow: hidden"
                        v-if="!isAr"
                    >
                        <img
                            v-if="selectedImage"
                            class="img-fluid"
                            :src="selectedImage"
                            @click="imgZoomModalVisibility = true"
                            style="
                                height: auto;
                                max-height: 100%;
                                width: auto;
                                max-width: 100%;
                                object-fit: contain;
                                transition: all 0.2s ease-in-out;
                                "
                        />
                        <div v-else>
                            <Skeletor
                                class="label"
                                style="
                                    margin-bottom: 0.5rem;
                                    width: 100%;
                                    height: 500px;
                                    border-radius: 0;
                                "
                            />
                        </div>
                    </div>
                    <div class="col-11" v-else-if="isAr">
                        <ARModelView
                            :designUrl="design3DUrl"
                            @openQrModal="openQrModal"
                        />
                    </div>
                </div>
                
                <div class="d-flex justify-content-center mt-4">
                    
                    <carousel
                        style="width: 100%"
                        ref="myCarousel"
                        :breakpoints="breakpoints"
                        :settings="settings"
                        class="gallery-slide-images"
                        :wrap-around="true"
                    >
                        <template #slides>
                            <slide v-for="(img, j) in imagesArr" :key="j">
                                <div class="cursor-pointer w-100 mx-2 h-100" ref="categoryContainer">
                                    <div class="w-100 h-100">
                                        <div class="slide-item-img bg-img-contain w-100 h-100" :class="{'active-slide':selectedImage == img && isClicked > -1}" @click="setImage(img)" style="background-color: #f4f4f4; height: 150px !important; max-height: 150px" :style="{ backgroundImage: `url(${img})`}"></div>
                                    </div>
                                </div>
                            </slide>
                        </template>

                        <template #addons>
                            <Navigation />
                        </template>
                    </carousel>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-6 col-md-6 col-sm-12 position-relative">
            <MainRightSection
                :item="itemRef"
                :attributes="attributes"
                :details="details"
                :articles="articles"
                @selectImage="selectImage"
                @selectFinishes="selectFinishes"
                :howToCare="howToCare"
            />
            <div id="myresult" class="img-zoom-result"></div>
        </div>
    </div>
    <div v-else>
        <MainSectionShimmer />
    </div>
    <CommonsModalBaseModal
        :show="imgZoomModalVisibility && screenWidth > 767"
        @close="imgZoomModalVisibility = false"
        :modalFooter="false"
        maxWidth="50%"
        maxHeight="80vh"
        bodyStyle="padding: 0 !important"
        title=""
    >
        <ImageZoomer :images="imagesArr"/>
    </CommonsModalBaseModal>
    <CommonsModalBaseModal
        :show="qrModalVisibility"
        @close="qrModalVisibility = false"
        :modalFooter="false"
        maxWidth="30%"
        bodyStyle="padding: 0 !important"
        title="QR Code"
    >
        <QRGenerator />
    </CommonsModalBaseModal>
    <CommonsModalBaseFullScreenModal
        :show="arModelVisibility"
        @close="arModelVisibility = false"
        :modalFooter="false"
        maxWidth="100%"
        maxHeight="100vh"
        bodyStyle="padding: 0 !important"
    >
        <ARModelView
            :designUrl="design3DUrl"
            @openQrModal="openQrModal"
            height="100vh"
        />
    </CommonsModalBaseFullScreenModal>
    <CommonsModalBaseModal
        :show="wishlistModalVisibility"
        @close="wishlistModalVisibility = false"
        :modalFooter="true"
        maxWidth="30%"
        bodyStyle="padding: 0 !important"
        title="Wishlist Remove"
    >   
        <div class="d-flex flex-column justify-content-center align-items-center p-3">
            <h5>Remove {{ title }} from Wishlist.</h5>
            <h3>Are you sure?</h3>
        </div>
        <template #action>
            <FormBaseButton
                caption="Confirm"
                icon=""
                @click.prevent="removeWishlist"
                class="btn btn-danger" 
                data-bs-dismiss="modal"
                color="btn-secondary"
            />
        </template>
    </CommonsModalBaseModal>
</client-only>
</template>

<script setup>
import MainRightSection from "./MainRightSection.vue";
import { cmsClient, wishlistsClient } from "@/assets/apis/config";
import { Skeletor } from "vue-skeletor";
import "vue-skeletor/dist/vue-skeletor.css";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import { useItemDetailDto } from "@/composables/item-detail/useItemDetailDto";
import MainSectionShimmer from "./MainSectionShimmer.vue";
import ARModelView from "./component/ARModelViewV2.vue";
import ImageZoomer from "@/components/commons/nav/ImageZoomer.vue";
import QRGenerator from "@/components/commons/nav/QRGenerator.vue";
import { useAuthStore } from "@/stores/auth-store";
import { useWishlistStore } from "@/stores/wishlist-store";
import ImageSlideShow from "./ImageSlideShow.vue";

const authStore = useAuthStore();
const wishlistStore = useWishlistStore();

const props = defineProps({
    item: {
        type: Object,
        default: null,
    },
    loading: {
        type: Boolean,
        default: false,
    },
    attributes: {
        type: Array,
        default: () => [],
    },
    details: {
        type: Object,
        default: () => [],
    },
    articles: {
        type: Object,
        default: () => [],
    },
    howToCare: {
        type: Object,
        default: () => [],
    },
});

const emit = defineEmits(["selectFinishes"]);

const screenWidth = ref(process.client ? screen.width : 0);
const modalWidth = ref(30);
const itemRef = toRef(props, "item");
const skuImages = ref([]);
const selectSku = ref([]);
const myImgRef = ref("");
const selectedImage = ref("");
const isAr = ref(false);
const imgZoomModalVisibility = ref(false);
const qrModalVisibility = ref(false);
const arModelVisibility = ref(false);
const wishlistModalVisibility = ref(false);
const isClicked = ref(-1);

// for static image, later need to dynamic it
const imagesArrV2 = ref([
    "/images/landing/Bed-1.png",
    "/images/landing/Bed-01.png",
    "/images/landing/Bed-02.png",
    "/images/landing/Bed-03.png",
    "/images/landing/Bed-04.png",
]);

const arActive = async () => {
    isAr.value = !isAr.value;
};

const selectFinishes = (item) => {
    emit("selectFinishes", item);
};
const settings = ref({
    itemsToShow: 5,
    snapAlign: "start",
});

const breakpoints = ref({
    0: {
        itemsToShow: 1,
        snapAlign: "start",
    },
    350: {
        itemsToShow: 1.5,
        snapAlign: "center",
    },
    650: {
        itemsToShow: 3,
        snapAlign: "center",
    },
    1024: {
        itemsToShow: 4,
        snapAlign: "start",
    },
});
const { title, images, design3DUrl } = useItemDetailDto(itemRef, []);

watch(
    screenWidth,
    () => {
        if (screenWidth.value < 991) {
            modalWidth.value = 60;
        }
    },
    { immediate: true }
);

const imagesArr = computed(() => {
    let img = [];
    if (props.item && props.item.id && props.item.id.length > 0) {
        if (skuImages.value && skuImages.value.length > 0) {
            if (selectSku.value && selectSku.value.length > 0) {
                let hasItem = false;
                for (let i = 0; i < skuImages.value.length; i++) {
                    const element = skuImages.value[i];
                    let hasSkuImg = selectSku.value.filter(
                        (i) =>
                            i.optionId == element.optionId && i.id == element.id
                    );
                    if (hasSkuImg.length > 0) {
                        img = element.urls;
                        hasItem = true;
                        break;
                    }
                }
                if (hasItem == false) {
                    img = images.value;
                }
            }
        }
    }
    if (!img.length) {
        if (images.value?.length > 0) {
            img = images.value;
        }
    }
    if (img.length > 2) {
        let secondImg = img.splice(1, 1);
        img.push(secondImg[0]);
    }

    return img;
});

watch(imagesArr, () => {
    selectedImage.value =
        imagesArr.value && imagesArr.value.length > 0
            ? imagesArr.value[0]
            : images.value[0];
});

selectedImage.value =
    imagesArr.value && imagesArr.value.length > 0
        ? imagesArr.value[0]
        : images.value[0];

const setImage = async (img) => {
    isClicked.value = 1;
    selectedImage.value = img;
};

const openQrModal = () => {
    arModelVisibility.value = false;
    qrModalVisibility.value = true;
}
const selectImage = (val) => {
    selectSku.value = val;
    if (props.item && props.item.id && props.item.id.length > 0) {
        if (skuImages.value && skuImages.value.length > 0) {
            if (val && val.length > 0) {
                let hasItem = false;
                for (let i = 0; i < skuImages.value.length; i++) {
                    const element = skuImages.value[i];

                    let hasSkuImg = val.filter(
                        (i) =>
                            i.optionId == element.optionId && i.id == element.id
                    );
                    if (hasSkuImg.length > 0) {
                        imagesArr.value = element.urls;
                        selectedImage.value = element.urls[0];
                        hasItem = true;
                        break;
                    }
                }
                if (hasItem == false) {
                    imagesArr.value = images.value;
                    selectedImage.value = images.value[0];
                }
            }
        }
    }
};

const imageFullScreen = () => {
    if (design3DUrl.value?.length) {
        arModelVisibility.value = true
    } else {
        imgZoomModalVisibility.value = true
    }
}

const fetchVariantsImages = (id) => {
    cmsClient.fetchVariantsImages({ itemId: id, size: 50 }).then((res) => {
        if (res.status == 200 && !res.networkError) {
            if (res.body && res.body.list && res.body.list.length > 0) {
                let newVal = [];
                let list = res.body.list.sort((x, y) => x.seq - y.seq);
                list.forEach((val) => {
                    let index = 0;
                    let hasVal = newVal.filter(
                        (i) => i.optionId == val.optionId && i.id == val.valueId
                    );
                    if (hasVal.length > 0) {
                        let findVal = newVal.findIndex(
                            (i) => i.id == hasVal[0].id
                        );
                        if (findVal > -1) {
                            let imgNum = `imageUrl${val.seq + 1}`;
                            newVal[findVal][imgNum] = val.url;
                            newVal[findVal].urls.push(val.url);
                        }
                    } else {
                        let obj = {
                            id: val.valueId,
                            optionId: val.optionId,
                            imageUrl1: "",
                            imageUrl2: "",
                            imageUrl3: "",
                            imageUrl4: "",
                            urls: [],
                            index: index,
                        };
                        let imgNum = `imageUrl${val.seq + 1}`;
                        obj[imgNum] = val.url;
                        obj.urls.push(val.url);
                        newVal.push(obj);
                        index++;
                    }
                });
                skuImages.value = newVal;
            }
        }
    });
};

watch(
    () => props.item,
    () => {
        if (props.item && props.item.id && props.item.id.length > 0) {
            fetchVariantsImages(props.item.id);
            selectedImage.value =
                imagesArr.value && imagesArr.value.length > 0
                    ? imagesArr.value[0]
                    : images.value[0];
        }
    },
    { immediate: true },
    { deep: true }
);

watch(
    selectSku,
    () => {
        if (skuImages.value && skuImages.value.length > 0) {
            if (selectSku.value && selectSku.value.length > 0) {
                let hasItem = false;
                for (let i = 0; i < skuImages.value.length; i++) {
                    const element = skuImages.value[i];

                    let hasSkuImg = selectSku.value.filter(
                        (i) =>
                            i.optionId == element.optionId && i.id == element.id
                    );
                    if (hasSkuImg.length > 0) {
                        imagesArr.value = element.urls;
                        selectedImage.value = element.urls[0];
                        hasItem = true;
                        break;
                    }
                }
                if (hasItem == false) {
                    imagesArr.value = images.value;
                    selectedImage.value = images.value[0];
                }
            }
        }
    },
    { immediate: true },
    { deep: true }
);

const isActive = computed(() => {
    let active = false;
    if (props.item && props.item.id) {
        
        // let isExists = wishlistStore.isExists(
        let isExists = wishlistStore.isItemExists(props.item.id);
        if (isExists) {
            active = true;
        }
    }
    return active;
});

const addToWishList = async () => {
    if (isActive.value) {
        wishlistModalVisibility.value = true;
    } else {
        let title = props.item.title;
        let data = {
            itemId: props.item.id,
            skuCode: "",
            wishlistId: "",
        };
        wishlistsClient.create(data).then((res) => {
            if (res.status == 201 && !res.networkError) {
                // toaster.success(`${title} Successfully added to Wishlist`, {
                //     duration: 1500,
                // });
                wishlistStore.updateList(data);
            } else {
                // toaster.error(`${title} Failed to add Wishlist`, {
                //     duration: 1500,
                // });
            }
        });
    }
};

const removeWishlist = async () => {
    if (!props.item?.id?.length) {
        return;
    }
    let wishlistItem = await wishlistStore.findWishlistItem(props.item.id);
    let data = {
        itemId: wishlistItem.itemId,
        // wishlistId: wishlistItem.wishlistId,
        userId: wishlistItem.userId,
        // skuCode: wishlistItem.skuCode,
    };
    wishlistsClient.delete(data).then((res) => {
        if (res.status == 202 && !res.networkError) {
            // toaster.success(`${title} Successfully removed from Wishlist`, {
            //     duration: 1500,
            // });
            wishlistStore.removeItem(data);
        } else {
            // toaster.error(`${title} Failed to remove from Wishlist`, {
            //     duration: 1500,
            // });
        }
        wishlistModalVisibility.value = false;
    });
};

function imageZoom(imgID, resultID) {
    if (process.client) {
        var img, lens, result, cx, cy;
        img = document.getElementById(imgID);
        result = document.getElementById(resultID);
        img.height = 660;

        /*create lens:*/
        lens = document.createElement("DIV");
        lens.setAttribute("class", "img-zoom-lens");

        /*insert lens:*/
        img.parentElement.insertBefore(lens, img);

        /*calculate the ratio between result DIV and lens:*/
        cx = result.offsetWidth / lens.offsetWidth; // depends on result div width
        cy = result.offsetHeight / lens.offsetHeight; // depends on result div height

        let imgWidth = img.width < 800 ? 800 : img.width;
        let imgHeight = img.height < 660 ? 660 : img.height;

        /*set background properties for the result DIV:*/
        result.style.backgroundImage = "url('" + selectedImage.value + "')";
        result.style.backgroundSize =
            imgWidth * (cx / 2) + "px " + imgHeight * (cy / 2) + "px";

        /*execute a function when someone moves the cursor over the image, or the lens:*/
        lens.addEventListener("mousemove", moveLens);
        img.addEventListener("mousemove", moveLens);

        /*and also for touch screens:*/
        lens.addEventListener("touchmove", moveLens);
        img.addEventListener("touchmove", moveLens);

        lens.addEventListener("mouseover", mouseOver);
        lens.addEventListener("mouseout", mouseOut);

        img.addEventListener("mouseover", mouseOver);
        img.addEventListener("mouseout", mouseOut);

        function mouseOver() {
            lens.style.visibility = "visible";
            result.style.visibility = "visible";
        }

        function mouseOut() {
            lens.style.visibility = "hidden";
            result.style.visibility = "hidden";
        }
        function moveLens(e) {
            e.preventDefault();
            const pos = getCursorPos(e);
            let x = pos.x - lens.offsetWidth / 2;
            let y = pos.y - lens.offsetHeight / 2;
            x = Math.min(Math.max(x, 0), img.width - lens.offsetWidth);
            y = Math.min(Math.max(y, 0), img.height - lens.offsetHeight);
            lens.style.left = x + "px";
            lens.style.top = y + "px";
            result.style.backgroundPosition = `-${x * (cx / 2.4)}px -${
                y * (cy / 2.4)
            }px`;
        }

        function getCursorPos(e) {
            const a = img.getBoundingClientRect();
            const x = e.pageX - a.left - window.pageXOffset;
            const y = e.pageY - a.top - window.pageYOffset;
            return { x, y };
        }
    }
}

function initializeImageZoom() {
    if (process.client && screenWidth.value > 991 && selectedImage.value.length) {
        const lens = document.querySelector(".img-zoom-lens");
        if (lens) {
            lens.style.visibility = "visible";
        }
        imageZoom("myimage", "myresult");
    }
}

watch(
    selectedImage,
    () => {
        if (selectedImage.value) {
            setTimeout(() => {
                initializeImageZoom();
            }, 200);
        }
    },
    { deep: true }
);
</script>

<style lang="scss" scoped>
.img-grid {
    width: 150px;
    height: auto;
    overflow: hidden;
}

.active-slide {
    // border: 1px solid #f69320 !important;
    // box-shadow: 0 1px 21px #e6e6e6;
    // transition: all 0.2s ease-in-out;
    background-color: rgba(0, 0, 0, 0.3) !important;
}

.img-zoom-result {
    // border: 1px solid #d4d4d4;
    /*set the size of the result div:*/
    width: 100%;
    height: 70vh;
    // height: 500px;

    background-repeat: no-repeat;
    background-color: #fff;
    // display: none;
    visibility: hidden;
    position: absolute;
    top: 0px;
    left: -10px;
    transform: translateX(0%);
}

.ar-bg-text {
    background-color: #afacac;
    width: 70%;
    border: 2px solid #afacac;
    padding: 0px 20px;
    font-size: 1rem !important;
    display: flex;
    // justify-content: space-between;
    justify-content: center;
    align-items: center;
    text-align: center;

    img {
        width: 40px;
    }

    .bg-text-img-white {
        display: none;
    }

    .bg-text-img {
        display: block;
    }

    &:hover {
        .bg-text-img-white {
            display: block;
        }

        .bg-text-img {
            display: none;
        }

        background: #000;
        color: #fff;
        border: 2px solid #000;
    }
}
</style>

<style lang="scss">
.details-main-container {
    .img-zoom-lens {
        position: absolute;
        border: 1px solid #d4d4d4;
        /*set the size of the lens:*/
        width: 100px;
        height: 100px;
        // background-color: #b61111;
        z-index: 999;
        background-color: hsla(0, 0%, 100%, 0.5);
        // position: absolute;
        visibility: hidden;
    }
}
// .gallery-images {
//     .carousel__viewport {
//         padding: 15px;
//         margin: 0 7.4%;
//         .carousel__track {
//             margin: 0 !important;
//         }
//     }
//     .carousel__slide {
//     }

//     .carousel__prev,
//     .carousel__next {
//         width: 20px !important;
//         height: 20px !important;
//         background-color: rgba(0, 0, 0, 0.3);
//         border-radius: 50%;
//     }

//     .carousel__prev {
//     }

//     .carousel__next {
//     }

//     .carousel__prev,
//     .carousel__next {
//         font-size: 1.2rem;
//         color: #fff;
//         // color: #f69320;
//     }
// }

.gallery-slide-images {
    .carousel__slide {}

    .carousel__prev,
    .carousel__next {
        width: 20px !important;
        height: 20px !important;
        background-color: rgba(0, 0, 0, 0.3);
        border-radius: 50%;
    }
    .carousel__prev {
        margin-left: -2%;
    }

    .carousel__next {
        margin-right: -2%;
    }

    .carousel__prev,
    .carousel__next {
        font-size: 2rem;
        color: #fff
    }

    @media screen and (max-width: 1023px) {
        
    .carousel__track {
        transform-style: preserve-3d;
    }
    .carousel__slide--sliding {
        transition: 0.5s;
    }

    .carousel__slide {
        opacity: 0.9;
        transform: rotateY(-20deg) scale(0.9);
    }

    .carousel__slide--active ~ .carousel__slide {
        transform: rotateY(20deg) scale(0.9);
    }

    .carousel__slide--prev {
        opacity: 1;
        transform: rotateY(-10deg) scale(0.95);
    }

    .carousel__slide--next {
        opacity: 1;
        transform: rotateY(10deg) scale(0.95);
    }

    .carousel__slide--active {
        opacity: 1;
        transform: rotateY(0) scale(1.1);
    }
}

}

.wishlist {
    &:hover {
        fill: red !important;
    }
}
.active-wishlist {
    fill: red !important;
}

.wish-link {
    width: 100%;
    height: 100%;
    //   background-color: #f6f8fa;
    border-radius: 50%;
    text-align: center;
    line-height: 35px;
    display: inline-block;

    i:hover {
        color: #f55050;
    }

    .fa-heart-o {
        display: block;
    }

    .fa-heart {
        display: none;
    }

    &:hover {
        .fa-heart-o {
            display: none;
        }

        .fa-heart {
            display: block;
            color: #f55050;
        }
    }
}

.wish-link svg {
    width: 35px;
    height: 35px;
    visibility: hidden;
}

.wish-link svg path {
    fill: transparent;
    stroke: #7e7e7f;
    stroke-width: 15px;
}

.wish-link:hover svg path,
.wish-link.focus svg path {
    fill: #f55050;
    stroke: #f55050;
}
</style>
